import { render, staticRenderFns } from "./SettingsTestWebhooks.vue?vue&type=template&id=177d350d&scoped=true"
import script from "./SettingsTestWebhooks.vue?vue&type=script&lang=js"
export * from "./SettingsTestWebhooks.vue?vue&type=script&lang=js"
import style0 from "./SettingsTestWebhooks.vue?vue&type=style&index=0&id=177d350d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d350d",
  null
  
)

export default component.exports